<template>
  <div class="p-3 text-left">
    <h2>{{ $t('general.user') }}</h2>
    <hr />
    <el-button size="small" @click="onUserAdd">
      {{ $t('general.add_user') }}
    </el-button>
    <transition name="page" appear>
      <el-card class="mt-2">
        <table class="el-table el-table--striped el-tab">
          <thead>
            <tr>
              <th>{{ $t('general.status') }}</th>
              <th>{{ $t('general.firstname') }}</th>
              <th>{{ $t('general.lastname') }}</th>
              <th>{{ $t('general.company') }}</th>
              <th>{{ $t('general.email') }}</th>
              <th>{{ $t('general.phone') }}</th>
              <th>{{ $t('general.address') }}</th>
              <th>{{ $t('general.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id" @click="onUserSelect(user)">
              <td>
                <el-tag :type="user.get('isActive') ? 'success' : 'danger'" size="mini" class="text-uppercase">
                  {{ $t(user.get('isActive') ? 'general.active' : 'general.inactive') }}
                </el-tag>
              </td>
              <td>{{ user.get('firstname') }}</td>
              <td>{{ user.get('lastname') }}</td>
              <td>{{ user.get('company') }}</td>
              <td>{{ user.get('username') }}</td>
              <td>{{ user.get('phone') }}</td>
              <td>
                {{
                  `${user.get('country') || ''}-${user.get('zipCode') || ''} ${user.get('city') || ''}, ${user.get(
                    'street'
                  ) || ''} ${user.get('streetAdditional') || ''}`
                }}
              </td>
              <td>
                <el-button type="info" circle>
                  <i class="el-icon-arrow-right" />
                </el-button>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </el-card>
    </transition>
  </div>
</template>

<script>
import RegisterUserModal from '../../../components/modals/RegisterUserModal';
import PlatformMixin from '../../../mixins/PlatformMixin';

export default {
  name: 'AdminUserView',
  components: {},
  mixins: [PlatformMixin],
  props: {},
  async mounted() {
    let query = new this.$parse.Query(this.$parse.User);
    query.limit(3000);
    this.users = await query.find();
  },
  destroyed() {},
  data() {
    return {
      users: [],
    };
  },
  computed: {},
  methods: {
    onUserAdd() {
      this.$modal.show(RegisterUserModal, {}, { height: 'auto', width: '90%' });
    },
    onUserSelect(user) {
      this.$router.push({ name: this.$routeNames.ADMIN_USER_DETAIL_PAGE_ROUTE, params: { id: user.id } });
    },
  },
};
</script>

<style scoped></style>
